module.exports = __webpack_public_path__ + "static/img/54.7fb33ad7.png";